export default __webpack_public_path__ + "static/media/head-back.1b794aa7.png";